import CustomIcon, {IconType} from '@src/components/shared/custom-icon/custom-icon';
import CustomButton from '@src/components/shared/custom-button/custom-button';
import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {SubscriptionFrequency} from '@src/dtos/user-subscription.dto';
import {useStores} from '@src/components/store';
import UserSettingsModal from '@src/components/features/user-settings/user-settings-modal';


export const ReportSubscriptionButton: React.FC = observer(() => {
    const { customerStore } = useStores();
    const [isUserSettingsModalOpen, setIsUserSettingsModalOpen] = useState<boolean>(false);

    useEffect(() => {
        const getSubscriptionData = async () => {
            try {
                if (await customerStore.getIsEligibleForExecutiveReport()) {
                    await customerStore.getFrequencyOfExecutiveSummaryReport();
                }
            } catch (err) {
                console.error('Failed to fetch user Report Subscription data: ', err);
            }
        };
        void getSubscriptionData();
    }, [customerStore.customerId]);

    const frequency = customerStore.frequencyOfExecutiveSummaryReport ?? SubscriptionFrequency.OFF;
    return (
        <>
        { customerStore.isEligibleForExecutiveReport &&
            <CustomButton
                prefixIcon={<CustomIcon type={frequency === SubscriptionFrequency.OFF ? IconType.ENVELOPE : IconType.ENVELOPE_V}/>}
                label={'Subscribe'}
                className={`subscription ${frequency === SubscriptionFrequency.OFF ? ' off' : ' active'}`}
                onClick={() => setIsUserSettingsModalOpen(true)}
            />
        }
        { isUserSettingsModalOpen &&
            <UserSettingsModal onCloseHandler={() => setIsUserSettingsModalOpen(false)} initialPersonalTab={true} />
        }
        </>
    );
});